var map = {
	"./ACB.png": 3772,
	"./AGRIBANK.png": 5030,
	"./AMERICANEXPRESS.png": 6217,
	"./BACABANK.png": 7361,
	"./BIDV.png": 3110,
	"./DONGABANK.png": 5918,
	"./EXIMBANK.png": 4478,
	"./HD BANK.png": 4158,
	"./JCB.png": 9880,
	"./MASTERCARD.png": 9933,
	"./MB.png": 7425,
	"./MSB.png": 6376,
	"./NAMABANK.png": 1400,
	"./NCB.png": 1393,
	"./OCB.png": 6912,
	"./OCEANBANK.png": 4098,
	"./PVCB.png": 5158,
	"./SACOMBANK.png": 5402,
	"./SHB.png": 1151,
	"./TECHCOMBANK.png": 6791,
	"./TPBANK.png": 9531,
	"./VIETCOMBANK.png": 424,
	"./VIETINBANK.png": 6103,
	"./VISA.png": 3932,
	"./VPBANK.png": 7349
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4343;